import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconExplosion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconExplosion"><G ClipPath="url(#clip0_7621_69619)"><Path d="M11.9999 0.816406L9.50117 5.66635L1.64623 1.64623L5.66635 9.50117L0.816406 11.9999L5.80056 14.5677L4.09196 19.9078L9.43203 18.1992L11.9999 23.1833L14.4985 18.3334L22.3535 22.3535L18.3334 14.4985L23.1833 11.9999L18.1992 9.43203L19.9078 4.09196L14.5677 5.80056L11.9999 0.816406Z" fill="currentColor"/></G><Defs><ClipPath id="clip0_7621_69619"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconExplosion;
